import { useEffect, useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'
import { nanoid } from 'nanoid'

import { RoutingPaths } from 'app/routes/routes'

import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'

import { priceShow } from 'shared/lib/priceShow'
import { SearchResultBlock } from 'shared/ui/search-result-block'

import { allDirectionsExcursionsStore } from '../popular-directions'

import s from './styles.module.scss'

export const AllDirectionList = observer(() => {
  const navigate = useNavigate()

  const listPopular = allDirectionsExcursionsStore.getAllDirections()

  const { t } = useTranslation()

  const getListPopular = () => {
    allDirectionsExcursionsStore.fetchAllDirections()
  }

  const onDetail = (index: number) => {
    const currentItem = listPopular?.[index]

    findExcursionsStore.onChangeDepartureDate(
      currentItem?.nearest_excursion_date || '',
    )

    if (currentItem) {
      navigate({
        pathname: RoutingPaths.excursion.excursionByDirection.path(
          currentItem?.id,
        ),
        search: `name=${currentItem?.name}`,
      })
    }
  }

  const preparedListPopular = useMemo(
    () =>
      listPopular?.map((popular) => ({
        id: popular?.id,
        image: popular?.image_url,
        title: popular?.name,
        price: String(popular?.price),
      })),
    [listPopular],
  )

  useEffect(() => {
    if (!listPopular?.length) {
      getListPopular()
    }
  }, [])

  return (
    <div className={s.container}>
      {preparedListPopular?.map((direction, index) => (
        <SearchResultBlock
          key={nanoid()}
          isExcursions
          subTitle={direction?.title}
          image={direction?.image}
          title={`${t('from_price', { price: priceShow(String(direction?.price)) })}`}
          onSelect={() => onDetail(index)}
        />
      ))}
    </div>
  )
})
